import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentSKUResponse } from '@/types/apps/component-sku.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentSKUGraphQLServiceInterface {}

type ComponentSKUGraphQLListResponse = GqlListResponse<ComponentSKUResponse>;

export class ComponentSKUGraphQLService
    extends BaseService
    implements ComponentSKUGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'partSKU';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            partCategoryCode: true,
            partCategoryId: true,
            partGroupCode: true,
            partGroupId: true,
            partTypeCode: true,
            partTypeId: true,
            partLifeTime: true,
            partType: {
                name: true,
                code: true,
            },
            partCategory: {
                code: true,
                id: true,
                name: true,
            },
            partGroup: {
                code: true,
                name: true,
                id: true,
                partCategory: {
                    code: true,
                    id: true,
                },
                partCategoryCode: true,
                partCategoryId: true,
                partTypeId: true,
                partTypeCode: true,
                partType: {
                    id: true,
                    name: true,
                    partCategoryCode: true,
                    partCategoryId: true,
                    partCategory: {
                        code: true,
                        id: true,
                        name: true,
                    },
                },
            },
        };
    }

    public async index(
        query: string
    ): Promise<ComponentSKUGraphQLListResponse> {
        return this.fetchGqlList<ComponentSKUGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('componentSKU', {
            userId: this.getQueryById(),
        });
    }
}
